// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
export const TenDLCCoordinatorService = {
    /**
     * RegisterPrivateProfitBrand will register the brand as a private for profit with TCR and if created will store the
     * resulting TCRBrand record in the database.
     * Private Profit brands automatically go through the TCR verification process. Results are instant and the brand
     * needs to come back with a "Verified" status in order to enroll in business messaging.
     * For positive verification the ein, company_name, display_name and address must match what is reported to the IRS.
     * NOTE: Each call results in a $4 charge unless "tcr_staging" and/or "mock" fields are true.
     * NOTE: This call is deprecated. Use RegisterPrivateProfitBrandAsync instead.
     */
    RegisterPrivateProfitBrand(fn, req) {
        return fn(`/tendlc/coordinator/v1/tcr-brand/private-profit`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * RegisterPrivateProfitBrandAsync will register the brand as a private for profit with TCR and if created will store the
     * resulting TCRBrand record in the database.
     * Private Profit brands automatically go through the TCR verification process. Results are delayed; the "identity status"
     * of the brand will return from this call as "unspecified". A later webhook from TCR will update the status of the brand
     * to either "verified" or "unverified". However, all other brand details are available immediately.
     * For positive verification the ein, company_name, display_name and address must match what is reported to the IRS.
     * NOTE: Each call results in a $4 charge unless "tcr_staging" and/or "mock" fields are true.
     */
    RegisterPrivateProfitBrandAsync(fn, req) {
        return fn(`/tendlc/coordinator/v1/tcr-brand/private-profit-async`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * RegisterSoleProprietorBrand will register the brand as a Sole Proprietor with TCR and if created will store the
     * resulting TCRBrand record in the database.
     * Sole Proprietors have a different verification process than Private Profit brands. Sole Proprietors always come
     * back immediately as unverified when created.
     * Sole Proprietor brands have more messaging restrictions than a verified Private/Profit brand. Namely:
     * - SPs can only register one campaign.
     * - SPs are restricted to a max of 5 registered campaign phone numbers.
     * - SPs are not allowed to send as many messages as private/profit brands.
     */
    RegisterSoleProprietorBrand(fn, req) {
        return fn(`/tendlc/coordinator/v1/tcr-brand/sole-proprietor`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * UpdateTCRBrand will update brand information in TCR and in Weave's database, overwriting existing fields
     * with the fields filled out in the request on success. The brand will also be reverified as necessary.
     * DO NOT fill out fields with existing brand information you're not changing. This may cause unnecessary
     * reverification of the brand.
     * See the documentation for the "reverify" field for information on what triggers brand reverification.
     * NOTE: Each call which attempts reverification results in a $4 charge, unless "tcr_staging" is true.
     */
    UpdateTCRBrand(fn, req) {
        return fn(`/tendlc/coordinator/v1/tcr-brand/update`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * GetTCRBrandLockStatus returns true if we've "locked" the ability to reverify a brand in TCR via
     * UpdateTCRBrand. Brands are locked after two failed verification attempts, and are unlocked only
     * after a successful verification. Locks can be overridden by setting the "override_lock" field
     * to true in UpdateTCRBrand.
     */
    GetTCRBrandLockStatus(fn, req) {
        return fn(`/tendlc/coordinator/v1/tcr-brand/lock-status?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * ListTCRBrands will return a list of TCRBrands matching the request search criteria.
     */
    ListTCRBrands(fn, req) {
        return fn(`/tendlc/coordinator/v1/tcr-brands?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * GetLocationTCRBrand will return a LocationTCRBrand if one exists.
     */
    GetLocationTCRBrand(fn, req) {
        return fn(`/tendlc/coordinator/v1/location-tcr-brand?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * AssignTCRBrandLocation assigns a location to a TCRBrand. Many locations can be assigned to a single TCRBrand.
     * One location cannot be assigned to more than one brand. Subsequently assigning a location to another TCRBrand
     * effectively re-assigns the location to the brand such that a location will only be assigned to at most 1 TCRBrand.
     * This only records an association between the location and the brand in Weave's database. It does not mean sms
     * traffic from the location will be registered with TCR.
     */
    AssignTCRBrandLocation(fn, req) {
        return fn(`/tendlc/coordinator/v1/location-tcr-brand`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * ConnectLocationToTCRBrand assigns a location to a TCRBrand and then, if the brand is verified, tries to make sure
     * that the location's primary outbound sms phone number will be registered to a campaign on that brand. ("tries" because
     * this may rely on TCR events triggering phone number registration later if a campaign with the right provider CNP does
     * not yet exist)
     */
    ConnectLocationToTCRBrand(fn, req) {
        return fn(`/tendlc/coordinator/v1/location-tcr-brand/connect`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * RegisterCampaign creates a new campaign for a specified brand and CNP in TCR.
     * If created successfully, followup steps (sharing the campaign, registering number to it)
     * will be handled automatically.
     */
    RegisterCampaign(fn, req) {
        return fn(`/tendlc/coordinator/v1/tcr-campaign`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * GetTCRCampaignApprovalStatus will return the campaign secondary DCA approval status for a given campaign.
     */
    GetTCRCampaignApprovalStatus(fn, req) {
        return fn(`/tendlc/coordinator/v1/tcr-campaign-approval-status?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * GetPhoneNumbersInfo returns information about the sms-capable phone numbers for a location,
     * including the outbound default sms phone number and its CNP.
     */
    GetPhoneNumbersInfo(fn, req) {
        return fn(`/tendlc/coordinator/v1/location-phone-info?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * AssignCampaignNumber attempts to register a phone number to a specified TCR campaign.
     * Only works if the campaign is approved.
     */
    AssignCampaignNumber(fn, req) {
        return fn(`/tendlc/coordinator/v1/tcr-campaign-number`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * RegisterPhoneNumber attempts to make sure a phone number will eventually be registered.
     * If there's already a matching, approved campaign, a registration attempt will be made immediately,
     * and the phone's registration status will be updated to "in progress" on success. Later, when
     * registration completes, the status will be automatically updated to "registered".
     * If there isn't a campaign, but one could plausibly be approved, that campaign will be created and
     * the phone number will be marked as pending so that it is registered upon campaign approval.
     * Returns the phone number's new detailed registration status. If the phone number
     * can't be registered, no error will be returned, but the status will explain why it can't be registered.
     */
    RegisterPhoneNumber(fn, req) {
        return fn(`/tendlc/coordinator/v1/tcr-phone-number`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * SearchEIN looks up a private company either by its EIN, or by its name and address.
     * NOTE: This call costs a small amount of money as it calls an external API.
     */
    SearchEIN(fn, req) {
        return fn(`/tendlc/coordinator/v1/ein-lookup?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * GetLocationRegistrationStatus returns the simple registration status the default sms number for a
     * location, as well as a list of all the location's phone numbers that are registered to a campaign.
     */
    GetLocationRegistrationStatus(fn, req) {
        return fn(`/tendlc/coordinator/v1/location-registration-status?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * GetLocationRegistrationStatusDetails returns the detailed registration status the default sms number for a
     * location, as well as a list of detailed registration statuses for all the location's phone numbers.
     */
    GetLocationRegistrationStatusDetails(fn, req) {
        return fn(`/tendlc/coordinator/v1/location-registration-status-details?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * GetPhoneNumberRegistrationStatus returns the simple 10DLC registration status for a phone number.
     */
    GetPhoneNumberRegistrationStatus(fn, req) {
        return fn(`/tendlc/coordinator/v1/phone-number-registration-status?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * GetPhoneNumberRegistrationStatusDetails returns the detailed 10DLC registration status for a phone number.
     */
    GetPhoneNumberRegistrationStatusDetails(fn, req) {
        return fn(`/tendlc/coordinator/v1/phone-number-registration-status-details?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * IsOnboardTaskBusinessInfoComplete returns true if the location is in an acceptable 10DLC registration state, such that Weave
     * does not want them to take any further action at this time.
     */
    IsLocationRegistrationComplete(fn, req) {
        return fn(`/tendlc/coordinator/v1/is-location-registration-complete?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * IsOnboardTaskBusinessInfoComplete returns true if the location has completed their onboarding task of
     * submitting their legal business information. Currently just a wrapper around IsLocationRegistrationComplete.
     */
    IsOnboardTaskBusinessInfoComplete(fn, req) {
        return fn(`/tendlc/coordinator/v1/is-onboard-task-business-info-complete?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * UpsertBrandCompliance will update brand compliance information in TCR and in Weave's database.
     * Empty fields will overwrite existing data; always supply a complete object (ignoring date fields).
     */
    UpsertBrandCompliance(fn, req) {
        return fn(`/tendlc/coordinator/v1/location-brand-compliance`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * GetLocationsBrandCompliance will return a list of LocationBrandCompliance records for the given location ids.
     */
    GetLocationsBrandCompliance(fn, req) {
        return fn(`/tendlc/coordinator/v1/location-brand-compliance?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
};
